var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSoundConfig = function SvgSoundConfig(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.99999V7.99999H2.66667L6 11.3333V0.666654L2.66667 3.99999H0ZM9 5.99999C9 4.81999 8.32 3.80665 7.33333 3.31332V8.67999C8.32 8.19332 9 7.17999 9 5.99999ZM7.33333 0.15332V1.52665C9.26 2.09999 10.6667 3.88665 10.6667 5.99999C10.6667 8.11332 9.26 9.89999 7.33333 10.4733V11.8467C10.0067 11.24 12 8.85332 12 5.99999C12 3.14665 10.0067 0.759987 7.33333 0.15332Z",
    fill: "currentColor",
    fillOpacity: 0.8
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSoundConfig);
export { ForwardRef as ReactComponent };